import { render, staticRenderFns } from "./EvntProcessInfoForm.vue?vue&type=template&id=0a0b6b9b&"
import script from "./EvntProcessInfoForm.vue?vue&type=script&lang=js&"
export * from "./EvntProcessInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports